// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  home: getIcon('ic_dashboard'),
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  bot: getIcon('ic_chat'),
  faq: getIcon('ic_list'),
  tov: getIcon('ic_user_voice'),
  settings: getIcon('ic_settings'),
  tickets: getIcon('ep--tickets'),
  admin: getIcon('ic_user')
};


const adminItems = [
  {
    title: 'Admin',
    path: PATH_DASHBOARD.general.admin,
    icon: ICONS.admin,
  }
];

export const adminSection = {
  subheader: 'admin',
  items: adminItems
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      /*      { title: 'Stats', path: PATH_DASHBOARD.general.statistics, icon: ICONS.dashboard }, */
      // { title: 'Trial Zone', path: PATH_DASHBOARD.general.trial, icon: ICONS.bot },
      { title: 'Dashboard', path: PATH_DASHBOARD.general.home, icon: ICONS.home },
      { title: 'Tickets', path: PATH_DASHBOARD.general.tickets, icon: ICONS.tickets },
      { title: 'QA Database', path: PATH_DASHBOARD.general.qa, icon: ICONS.faq },
      { title: 'Tone Of Voice', path: PATH_DASHBOARD.general.tov, icon: ICONS.tov },
      {
        title: 'Settings',
        icon: ICONS.settings,
        children: [
          {
            title: 'General',
            path: PATH_DASHBOARD.general.settings,
            icon: ICONS.settings,
          },
          {
            title: 'Integrations',
            path: PATH_DASHBOARD.general.settingsConnectors,
            icon: ICONS.settings,
          },
          {
            title: 'Automation',
            path: PATH_DASHBOARD.general.settingsAutomation,
            icon: ICONS.settings,
          },
          {
            title: 'Actions',
            path: PATH_DASHBOARD.general.settingsActions,
            icon: ICONS.settings,
          },
          {
            title: 'Products',
            path: PATH_DASHBOARD.general.settingsProduct,
            icon: ICONS.settings,
          },
          {
            title: 'Billing',
            path: PATH_DASHBOARD.general.settingsBilling,
            icon: ICONS.settings,
          }
        ]
      }
    ]
  }

  // MANAGEMENT
  // ----------------------------------------------------------------------
  /*   {
    subheader: 'management',
    items: [
      {
        title: 'user',
        path: PATH_DASHBOARD.app.root,
        icon: ICONS.user,
        children: [
          { title: 'Four', path: PATH_DASHBOARD.app.pageFour },
          { title: 'Five', path: PATH_DASHBOARD.app.pageFive },
          { title: 'Six', path: PATH_DASHBOARD.app.pageSix }
        ]
      }
    ]
  } */
];

export default sidebarConfig;
